import React from 'react';
import Button from '../../components/ui/Button';
import { authService } from '../../services/authService';

const SettingsSessions: React.FC = () => {
  const [sessions, setSessions] = React.useState<{ id: string; createdAt: string; expiresAt: string; current: boolean }[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [revoking, setRevoking] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await authService.listSessions();
      setSessions(res.sessions);
    } catch (e: any) {
      setError(e?.message || 'Failed to load sessions');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => { load(); }, []);

  const revoke = async (id: string) => {
    try {
      setRevoking(id);
      await authService.revokeSession(id);
      await load();
    } catch (e: any) {
      setError(e?.message || 'Failed to revoke session');
    } finally {
      setRevoking(null);
    }
  };

  const revokeOthers = async () => {
    try {
      setRevoking('others');
      await authService.revokeOtherSessions();
      await load();
    } catch (e: any) {
      setError(e?.message || 'Failed to revoke other sessions');
    } finally {
      setRevoking(null);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--patreon-black)' }}>Active sessions</h1>
      <p className="mb-4" style={{ color: 'var(--patreon-gray)' }}>Manage and revoke devices signed in to your account.</p>

      {error && <div className="mb-4 text-sm" style={{ color: 'var(--patreon-error)' }}>{error}</div>}

      <div className="mb-4">
        <Button onClick={revokeOthers} loading={revoking === 'others'}>Sign out of other devices</Button>
      </div>

      {loading ? (
        <div>Loading…</div>
      ) : (
        <div className="space-y-3">
          {sessions.map(s => (
            <div key={s.id} className="flex items-center justify-between p-4 rounded-lg" style={{ background: 'var(--patreon-card-bg)', border: '1px solid var(--patreon-card-border)' }}>
              <div>
                <div className="font-medium" style={{ color: 'var(--patreon-black)' }}>{s.current ? 'This device' : 'Signed-in device'}</div>
                <div className="text-sm" style={{ color: 'var(--patreon-gray)' }}>
                  Started {new Date(s.createdAt).toLocaleString()} · Expires {new Date(s.expiresAt).toLocaleString()}
                </div>
              </div>
              <div>
                <Button variant="outline" onClick={() => revoke(s.id)} disabled={s.current} loading={revoking === s.id}>
                  Revoke
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SettingsSessions;



